import { Payment } from '@sl/payment-sdk/lib/ec1';

const SHOPLINE_PAYMENT_CLIENT_ID = 'EC1.0';
const LANGUAGE_MAP = new Map([
  ['zh-cn', 'zh-CN'],
  ['zh-hant', 'zh-TW'],
  ['en', 'en'],
  ['de', 'de'],
  ['ru', 'ru'],
  ['fr', 'fr'],
  ['es', 'es'],
  ['ja', 'ja'],
  ['ko', 'ko'],
  ['th', 'th'],
]);
const PAYMENT_CHANNEL_ID_PAYMENT_METHOD_MAP = {
  paygent: {
    paypay: { channelId: 'PaygentOther', paymentMethod: 'PayPay' },
    rakuten_pay: { channelId: 'PaygentOther', paymentMethod: 'RakutenPay' },
    credit: { channelId: 'Paygent', paymentMethod: 'CreditCard' },
  },
};

export const getChannelIdAndPaymentMethod = (paymentMethod) => {
  return paymentMethod?.type && paymentMethod?.config_data?.payment_subtype
    ? PAYMENT_CHANNEL_ID_PAYMENT_METHOD_MAP[paymentMethod.type]?.[
        paymentMethod.config_data.payment_subtype
      ]
    : undefined;
};

export const getLanguage = (countryCode) => {
  return LANGUAGE_MAP.get(countryCode) || 'en';
};

export const getSLPaymentGatewayService = () => {
  const { merchantData, localeData, shoplinePaymentGatewayEnv } =
    window.mainConfig;

  return {
    getDefaultPaymentConfig: (originalPaymentMethod) => {
      const paymentConfig = getChannelIdAndPaymentMethod(originalPaymentMethod);
      if (!paymentConfig) {
        throw new Error('Invalid payment method configuration');
      }

      const { channelId, paymentMethod } = paymentConfig;

      return {
        clientId: SHOPLINE_PAYMENT_CLIENT_ID,
        paymentMethod,
        channelId,
        merchantId: originalPaymentMethod.config_data.sl_payment_merchant_id,
        countryCode: merchantData.base_country_code,
        currency: merchantData.base_currency_code,
        language: getLanguage(localeData.loadedLanguage.code),
        env: shoplinePaymentGatewayEnv,
        systemCode: 'standard_ec',
        needAdaptive: true,
        eventTrackingConfig: {
          url: 'https://events.shoplytics.com/api/v1/slp',
        },
      };
    },

    renderSDK: ({ paymentConfig, elementId }) => {
      return new Payment(paymentConfig, elementId).init();
    },
  };
};

export default getSLPaymentGatewayService();
